import { render, staticRenderFns } from "./ImportarExportarMargemExport.vue?vue&type=template&id=10c0d24a"
import script from "./ImportarExportarMargemExport.vue?vue&type=script&lang=js"
export * from "./ImportarExportarMargemExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports